import { jsx, jsxs } from 'react/jsx-runtime';
import { memo } from 'react';
import { isSlotType, isSimpleType } from './utils.esm.js';

const SelectableContent = memo(({ variant, label, secondaryLabel, children, contentColumn, labelClass, secondaryLabelClass, slotWrapper, labelWrapper, }) => {
    if (isSlotType(variant) && children) {
        return jsx("div", { className: slotWrapper(), children: children });
    }
    if (isSimpleType(variant)) {
        return (jsxs("div", { className: contentColumn(), children: [label && (jsx("div", { className: labelWrapper(), children: jsx("span", { "aria-hidden": "true", className: labelClass(), children: label }) })), secondaryLabel && (jsx("span", { "aria-hidden": "true", className: secondaryLabelClass(), children: secondaryLabel }))] }));
    }
    return null;
});
SelectableContent.displayName = "SelectableContent";

export { SelectableContent };
